import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver
import { toast } from "react-toastify";
import Pagination from "pages/Pagination/Pagination";
import Select from "react-select";
import { pageSize } from "components/PaginationPageSize";
import { formatRupee } from "utils/helpingMethods/formatRupee";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const JobWorkReports = () => {
  const [fYRecord, setFYRecord] = useState([]);
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  // const navigate = useNavigate();
  const gridRef = useRef();
  // Get the current date and format it as yyyy-mm-dd for the date input field
  const today = new Date();
  const [selectItem, setSelecteItem] = useState();
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [customerId, setCustomerId] = useState();
  const [supplierID, setSupplierID] = useState();
  const [customerList, setCustomerList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [fYList, setFYList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputSupplier, setSearchInputSupplier] = useState("");

  const [items, setItems] = useState([]);
  const [searchItemsInput, setSearchItemsInput] = useState("");
  const [selectedFY, setSelectedFY] = useState(null);

  const [searchInputFY, setSearchInputFY] = useState();
  const [searchInputFY2, setSearchInputFY2] = useState();

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0 = January, 3 = April
  useEffect(() => {
    if (!fYList?.length || selectedFY) return; // ❗ Prevent overriding user's selection

    const currentFinancialYear =
      currentMonth >= 3
        ? `${currentYear}-${currentYear + 1}`
        : `${currentYear - 1}-${currentYear}`;

    const defaultOption = fYList
      .map((fylist) => ({
        label: fylist.name,
        value: fylist.name,
      }))
      .find((option) => option.value === currentFinancialYear);

    if (defaultOption) {
      setSelectedFY(defaultOption);
      setSearchInputFY(defaultOption.value);
    }
  }, [fYList]);

  //for pagination...
  const [count, setCount] = useState();
  const [download, setDownload] = useState(false);

  //for serach fuctionallity ...

  const [recordPerPage, setRecordPerPage] = useState(pageSize);
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();
  const token = sessionStorage.getItem("token");
  const companyId = sessionStorage.getItem("companyId");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getCompanyDetails();
  }, []);
  useEffect(() => {
    getCustomerList();
    SupplierGet();
  }, [searchInput]);

  const getCustomerList = () => {
    axios
      .post("/api/purple-fusion/customer/get", { name: searchInput }, headers)
      .then((response) => {
        setCustomerList(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching Customers", error);
      });
  };
  const SupplierGet = () => {
    axios
      .post("/api/purple-fusion/supplier/get", {name: searchInputSupplier}, headers)
      .then((response) => {
        setSupplierList(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getFinancialYears();
  }, [searchInputFY2]);

  const getFinancialYears = () => {
    axios
      .post(
        "/api/purple-fusion/financialyear/get",
        { name: searchInputFY2 },
        headers
      )
      .then((response) => {
        setFYList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching FY", error);
      });
  };

  useEffect(() => {
    getItemList();
  }, [supplierID]);

  const getItemList = () => {
      const CompanyPurchase_obj = {
    supplier_id: supplierID,
    company_purchase_order_status_id: 1,
  };
    axios
      .post("/api/purple-fusion/CompanyPurchesOrder/get", CompanyPurchase_obj, {
        ...headers,
        timeout: 20000,
      })
      .then((res) => {
        const filterdata= res.data.filter((item)=>item.company_purchase_order_type_id===10 )
        setItems(filterdata);
        console.log("item", res.data);
      })
      .catch((e) => {
        console.error("Error in fetching data ", e);
      });
  };

  const filterOption = (option, inputValue) => {
    const { label, code, code_op } = option.data;

    const labelMatch =
      label?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeMatch =
      code?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeOpMatch =
      code_op?.toLowerCase().includes(inputValue.toLowerCase()) || false;

    return labelMatch || codeMatch || codeOpMatch;
  };

  const formatOptionLabel = ({ label, code, code_op }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ marginLeft: 0 }}>{label}</div>
      <div style={{ marginLeft: 20 }}>{code_op}</div>
      <div style={{ marginLeft: 20 }}>{code}</div>
    </div>
  );

  // console.log(companyId);
  const obj_company = { id: companyId };
  const getCompanyDetails = () => {
    axios
      .post("/api/purple-fusion/company/get", obj_company, headers)
      .then((response) => {
        setCompanyDetails(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  useEffect(() => {
    // if (!fYRecord || fYRecord.length === 0) return;

    // const totalRow = {
    //   // sr: "",
    //   month: "Total",
    //   grn_value: 0,
    //   dc_value: 0,
    //   balance_value: 0,

    // };

    // fYRecord.forEach((row) => {
    //   totalRow.grn_value += Number(row.grn_value || 0);
    //   totalRow.dc_value += Number(row.dc_value || 0);
    //   totalRow.balance_value += Number(row.balance_value || 0);
    // });
    // console.log("Total Row Data:", totalRow);

    // setPinnedBottomRowData([totalRow]);
  }, [fYRecord, selectItem, customerId, selectedFY, searchInputFY,supplierID]);

  useEffect(() => {
    getFYSales();
  }, [page, recordPerPage, selectItem, customerId, searchInputFY,supplierID]);

  const obj = {
    month: searchInputFY,
    customer_id: customerId,    
    supplier_id: supplierID,    
    purchase_order_id: selectItem?.value,
  };

  const getFYSales = () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;
    console.log(offset);

    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };
    console.log(requestPayload);
    axios
      .post(
        "/api/purple-fusion/reportstockregisterjobwork/get",
        requestPayload,
        headers
      )
      .then((response) => {
        setFYRecord(response.data);
        setCount(response.data[0].count);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const sortedInvoice = fYRecord
    .slice()
    .sort((a, b) => b.tax_invoice_id - a.tax_invoice_id);

  const onBtnExport = useCallback(async () => {
    const excludedFields = ["id"]; // Fields to exclude from the export
    const visibleColumns = defaultColDefs.filter(
      (column) => !excludedFields.includes(column.field)
    );

    // Retrieve all data from the grid
    const allRows = [];
    gridRef.current.api.forEachNode((node) => allRows.push(node.data));

    // Helper to format dates to dd/mm/yyyy
    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-GB"); // Format as dd/mm/yyyy
    };

    const formattedData = allRows.map((row) => {
      const formattedRow = {};

      visibleColumns.forEach((col) => {
        if (col.field === "createdon" && row[col.field]) {
          formattedRow[col.headerName] = formatDate(row[col.field]); // Format createdon as date-only
        } else if (col.headerName === "INTEGRATED TAX(igst)") {
          formattedRow["INTEGRATED TAX(igst)"] =
            row.igst_amount !== 0 && row.igst_amount !== undefined
              ? row.igst_amount
              : 0;
        } else if (col.headerName === "CENTRAL TAX(cgst)") {
          formattedRow["CENTRAL TAX(cgst)"] =
            row.cgst_amount !== 0 && row.cgst_amount !== null
              ? row.cgst_amount
              : 0;
        } else if (col.headerName === "STATE TAX(sgst)") {
          formattedRow["STATE TAX(sgst)"] =
            row.sgst_amount && row.sgst_amount !== 0 ? row.sgst_amount : 0;
        } else {
          formattedRow[col.headerName] = row[col.field] || "";
        }
      });

      return formattedRow;
    });

    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    console.log(companyDetails);

    if (companyDetails.length > 0) {
      worksheet.addRow(["Company Name:", `${companyDetails[0]?.name}`]);
      worksheet.addRow(["Company GSTIN:", `${companyDetails[0]?.gstnumber}`]);

      const address =
        `${companyDetails[0]?.city}, ` +
        `pincode: ${companyDetails[0]?.pincode}, ` +
        `distt.: ${companyDetails[0]?.district_name}, ` +
        `State: ${companyDetails[0]?.state_name}`;

      const addressRow = worksheet.addRow(["Company Address:", address]);

      const rowIndex = addressRow.number;

      // Merge columns B to E (or more, depending on your layout)
      worksheet.mergeCells(`B${rowIndex}:K ${rowIndex}`);

      // Optional: Wrap text in merged cell
      const cell = worksheet.getCell(`B${rowIndex}`);
      cell.alignment = { wrapText: true, vertical: "top" };
    }
    worksheet.addRow(["Report Name:", `FY Sale ${searchInputFY}`]); // Format from date as dd/mm/yyyy

    worksheet.addRow([]); // Add an empty row for spacing

    // Add header row
    const headers = visibleColumns.map((col) => col.headerName);
    worksheet.addRow(headers);

    // Freeze the header row
    let headerRow = null;
    if (companyDetails.length > 0) {
      worksheet.views = [{ state: "frozen", ySplit: 6 }];
    } else {
      worksheet.views = [{ state: "frozen", ySplit: 3 }];
    }

    // Style the header row
    if (companyDetails.length > 0) {
      headerRow = worksheet.getRow(6);
    } else {
      headerRow = worksheet.getRow(3);
    }
    // headerRow = worksheet.getRow(5);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" }, // Blue background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });
    headerRow.height = 30;

    formattedData.forEach((row, index) => {
      // Create an array of row data based on the headers
      const rowData = headers.map((header) => {
        const value = row[header];

        // Ensure 0 is explicitly set if it's missing or empty
        if (
          value === 0 ||
          value === "0" ||
          value === null ||
          value === undefined
        ) {
          return 0; // Explicitly return 0 for missing or empty values
        }

        return value || ""; // Return the value or an empty string if it's falsy
      });

      // Add the row to the worksheet
      const newRow = worksheet.addRow(rowData);
      newRow.height = 30; // Adjust row height

      // Iterate over each cell in the row for custom alignment
      newRow.eachCell((cell, colNumber) => {
        const columnHeader = headers[colNumber - 1]; // Map cell index to column header

        // Apply alignment based on data type

        // Apply number format for numeric values with comma separator
        if (typeof cell.value === "number") {
          cell.numFmt = cell.value % 1 === 0 ? "#,##0" : "#,##0.00"; // Integer vs decimal format
        }

        // If the cell value is 0, ensure it displays as "0" properly
        if (cell.value === 0) {
          cell.numFmt = "#,##0"; // Format zero correctly
        }
      });
    });

    // Add total row at the bottom of the table
    const formatNumberWithCommas = (num) => {
      if (isNaN(num) || num === null || num === undefined) return "";
      return new Intl.NumberFormat("en-IN").format(num);
    };

    const totalRow = {};
    headers.forEach((header) => {
      if (header === "Month-Year") {
        totalRow[header] = "Total"; // Add "Total" in the DESCRIPTION column
      } else if (
        [
          "BASIC AMOUNT",
          "IGST",
          "CGST",
          "SGST",
          "TOTAL TAX",
          "TOTAL AMOUNT",
        ].includes(header)
      ) {
        // Calculate total and format with commas
        const total = formattedData.reduce(
          (sum, row) => sum + (parseFloat(row[header]) || 0),
          0
        );
        totalRow[header] = formatNumberWithCommas(total);
      } else {
        totalRow[header] = ""; // Leave other columns blank
      }
    });

    // Add the total row to the worksheet
    const totalDataRow = headers.map((header) => totalRow[header] || "");
    const footerRow = worksheet.addRow(totalDataRow);

    // Style the footer row
    footerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "right" };
      if (cell.value) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFB7E1CD" }, // Light green background
        };
      }
    });
    footerRow.height = 30;

    // Generate Excel file as a Blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `FY_Sales_${searchInputFY}.xlsx`);
  }, [searchInputFY, selectItem]);

  const defaultColDefs = [
    { headerName: "Sr.No.", field: "sr", width: 85, headerClass: "font-bold" },
    {
      headerName: "P O No.",
      field: "purchase_order_code",
      width: 160,
      headerClass: "font-bold",
    },
    {
      headerName: "SUPPLIER NAME",
      field: "supplier_name",
      width: 150,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "GRN VALUE",
      field: "grn_value",
      width: 150,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "CUSTOMER NAME",
      field: "customer_name",
      width: 150,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "D C NO.",
      field: "delivery_challan_number",
      width: 120,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "DC VALUE",
      field: "dc_value",
      width: 150,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "BALANCED VALUE",
      field: "balance_value",
      width: 150,
      headerClass: "font-bold",
    //   valueFormatter: (params) => formatRupee(params.value),
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(defaultColDefs);
  }, []);

  const ColDefaultVale = { filter: true };
  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px", // Adjust control height
      height: "35px", // Adjust control height
      fontSize: "14px", // Adjust font size
      width: "230px", // Adjust control width
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "35px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "35px",
      padding: "0 8px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "350px",
      backgroundColor: "#fff", // Ensures a solid background
      zIndex: 1000, // Ensures it appears above other elements
    }),
  };

  return (
    <div>
      <div className="mb-1">
        <div className="flex flex-1 flex-row items-center justify-between w-full mt-1 pr-10 pl-5">
          <div className="flex flex-1 flex-row items-center justify-between w-full md:flex-col md:items-start md:justify-start sm:flex-col sm:items-start sm:justify-start ">
            <div className="flex flex-row gap-1 items-center">
            
              {/* <Select
                options={[
                  ...(fYList?.map((fylist) => ({
                    label: fylist.name,
                    value: fylist.name,
                  })) ?? []),
                ]}
                value={selectedFY}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm"
                onChange={(selectedOption) => {
                  setFYRecord([]);
                  setLoading(true);
                  setSelectedFY(selectedOption); // allow user selection
                  setSearchInputFY(selectedOption.value);
                }}
                onInputChange={setSearchInputFY2}
                placeholder="Financial year"
                styles={customStylesSelect}
              /> */}

               <Select
                options={[
                  { label: "All Supplier", value: "" },
                  ...supplierList.map((customer) => ({
                    label: customer.name,
                    value: customer.id,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm "
                onChange={(selectedOption) => {
                  setFYRecord([]);
                  setLoading(true);
                  setSupplierID(selectedOption.value);
                }}
                onInputChange={setSearchInputSupplier}
                placeholder="All supplier"
                styles={customStylesSelect}
              />


              <Select
                options={[
                  { label: "All Customers", value: "" },
                  ...customerList.map((customer) => ({
                    label: customer.name,
                    value: customer.id,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm "
                onChange={(selectedOption) => {
                  setFYRecord([]);
                  setLoading(true);
                  setCustomerId(selectedOption.value);
                }}
                onInputChange={setSearchInput}
                placeholder="All Customer"
                styles={customStylesSelect}
              />
              <Select
                options={[
                  { label: "All Supplier PO", value: null },
                  ...items.map((item) => ({
                    value: item.id,
                    code: item.code,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm"
                onChange={(selectedOption) => {
                  setFYRecord([]);
                  setLoading(true);
                  setSelecteItem(selectedOption);
                }}
                filterOption={filterOption}
                formatOptionLabel={formatOptionLabel}
                onInputChange={setSearchItemsInput}
                placeholder="Select Supplier PO"
                isSearchable
                styles={customStylesSelect}
              />
            </div>
            <div className="flex text-3xl  justify-end items-end font-inter px-[10px] leading-none  text-gray-900 md:text-4xl lg:text-5xl dark:text-white ">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex-1 min-w-[320px] max-w-full border border-gray-200 shadow-md rounded-2xl bg-white-A700  m-1 
                hover:shadow-lg hover:shadow-blue-200 transition-shadow duration-300"
      >
        <div
          className="ag-theme-quartz"
          style={{ height: 435, width: "100%", fontSize: "12px" }}
          id="my-table1"
        >
          <AgGridReact
            rowData={sortedInvoice.map((item, index) => ({
              ...item,
              sr: index + (offsetforSR + 1),
              // Display "NA" if code_op is null
            }))}
            ref={gridRef}
            columnDefs={colDefs}
            getRowClass={(params) => {
              if (params.node.rowPinned === "bottom") {
                return "my-pinned-bottom-row";
              }
              return "";
            }}
            pinnedBottomRowData={pinnedBottomRowData}
            defaultColDef={ColDefaultVale}
            suppressMenuHide={true}
            suppressExcelExport={true}
            rowHeight={37}
            overlayLoadingTemplate={loading ? "Loading..." : null}
            overlayNoRowsTemplate={
              loading
                ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                : "No Record Found"
            }
          />
        </div>
        <div>
          <Pagination
            count={count}
            setRecordPerPage={setRecordPerPage}
            recordPerPage={recordPerPage}
            setLoading={setLoading}
            setData={setFYRecord}
            setPage={setPage}
            page={page}
          />
        </div>
      </div>
      {/* <div
        className="flex-1 min-w-[320px] max-w-full border border-gray-200 shadow-md rounded-2xl bg-white-A700 p-4 mx-1 my-4 
                      hover:shadow-lg hover:shadow-blue-200 transition-shadow duration-300"
      >
        <h3 className="text-sm font-semibold text-gray-700 mb-3">
          Monthly Tax & Amount Trend
        </h3>
        <ResponsiveContainer width="100%" height={360}>
          <LineChart
            data={sortedInvoice}
            margin={{ top: 10, right: 30, left: 10, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis
              dataKey="month"
              tick={{ fontSize: 11, fill: "#6b7280" }}
              axisLine={{ stroke: "#d1d5db" }}
            />
            <YAxis
              tickFormatter={(value) => formatRupee(value)}
              tick={{ fontSize: 11, fill: "#6b7280" }}
              axisLine={{ stroke: "#d1d5db" }}
            />
            <Tooltip
              formatter={(value) => formatRupee(value)}
              contentStyle={{
                backgroundColor: "white",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                fontSize: "12px",
              }}
            />
            <Legend
              wrapperStyle={{ fontSize: "12px" }}
              verticalAlign="bottom"
              height={30}
            />

            <Line
              type="monotone"
              dataKey="total_tax"
              stroke="#6366f1"
              strokeWidth={2}
              name="Total Tax"
              activeDot={{
                r: 8,
                fill: "#6366f1",
                strokeWidth: 2,
                stroke: "#fff",
              }}
            />
            <Line
              type="monotone"
              dataKey="total_amount"
              stroke="#10b981"
              strokeWidth={2}
              name="Total Amount"
              activeDot={{
                r: 8,
                fill: "#10b981",
                strokeWidth: 2,
                stroke: "#fff",
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div> */}
    </div>
  );
};

export default JobWorkReports;
